import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import nl from "./locales/nl.json";
import fr from "./locales/fr.json";
import en from "./locales/en.json";
import es from "./locales/es.json";

/**
 * i18n initialization.
 *
 * - Detects browser language on first visit (default fallback: NL)
 * - Persists choice in localStorage (`vsf_lang`)
 * - For logged-in users, AuthContext syncs `user.preferred_language`
 *   into i18next AND back to the DB whenever the user changes it.
 * - Supported: nl, fr, en. (es ready — drop in es.json + add to resources.)
 */
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            nl: { translation: nl },
            fr: { translation: fr },
            en: { translation: en },
            es: { translation: es },
        },
        fallbackLng: "nl",
        supportedLngs: ["nl", "fr", "en", "es"],
        load: "languageOnly", // map "fr-BE" → "fr"
        interpolation: { escapeValue: false },
        detection: {
            order: ["localStorage", "navigator"],
            lookupLocalStorage: "vsf_lang",
            caches: ["localStorage"],
        },
        returnNull: false,
    });

export default i18n;

export const SUPPORTED_LANGUAGES = [
    { code: "nl", label: "Nederlands", short: "NL", flag: "🇧🇪" },
    { code: "fr", label: "Français", short: "FR", flag: "🇫🇷" },
    { code: "en", label: "English", short: "EN", flag: "🇬🇧" },
    { code: "es", label: "Español", short: "ES", flag: "🇪🇸" },
];
